<div class="note-pop-up-v2">
  <div class="note-pop-up">
    <div
      class="input"
      [ngClass]="{ enable: textAreaTrigger.menuOpen === true, disable: textAreaTrigger.menuOpen === false }"
      (click)="textAreaTrigger.openMenu()"
    >
      <label class="text" [ngClass]="{ enable: textAreaTrigger.menuOpen === true, disable: textAreaTrigger.menuOpen === false }">
        {{ value && value.trim().length > 0 ? value : placeholder }}</label
      >
      <span class="fa" [ngClass]="{ 'fa-eye': textAreaTrigger.menuOpen === true, 'fa-eye-slash': textAreaTrigger.menuOpen === false }"></span>
      <span
        class="fa"
        [ngClass]="{
          'fa-check-circle': updateSuccess === true,
          'fa-times-circle': updateSuccess === false
        }"
      ></span>
    </div>
    <div [matMenuTriggerFor]="textAreaPopUp" #textAreaTrigger="matMenuTrigger">
      <mat-menu
        #textAreaPopUp="matMenu"
        panelClass="app-note-pop-up-v2-container"
        class="app-note-pop-up-v2-container"
        (closed)="closed()"
        yPosition="below"
        xPosition="after"
      >
        <div class="text-area-container" (click)="$event.stopPropagation()">
          <textarea maxlength="250" [(ngModel)]="note" class="text-area" rows="9" [disabled]="!canEdit"></textarea>
          <div class="text-length">{{ note.length }} / 250</div>
          <button (click)="save()" [disabled]="!canEdit || note.length <= 0 || value.trim() === note.trim()" class="btn btn-outline-primary">Speichern</button>
        </div>
      </mat-menu>
    </div>
  </div>
</div>
